module.exports = __webpack_public_path__ + "static/media/loop_short.169109f3.mp3";